export default {
	"lang": "en",
	"page-title": "시장 분석",
}